import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import { showProgress } from '../../../../services/utilityFunctions';

function Progress({ t, progress, showLabel, showPercent, label }) {
  return (
    <div className="course-progress">
      {showLabel && (
        <div className="course-progress-label">{label || t('progress')}</div>
      )}
      <div className="course-progress-values">
        <div className="course-progress-bar">
          <span style={{ width: `${Math.min(progress, 100)}%` }} />
        </div>
        {showPercent && (
          <span className="course-progress-value">{`${showProgress(
            progress,
          )}%`}</span>
        )}
      </div>
    </div>
  );
}

Progress.propTypes = {
  t: PropTypes.func.isRequired,
  progress: PropTypes.number.isRequired,
  showLabel: PropTypes.bool,
  showPercent: PropTypes.bool,
  label: PropTypes.string,
};

Progress.defaultProps = {
  showLabel: true,
  showPercent: true,
  label: '',
};

export default translate(Progress);
